import axios from 'axios';

const GET_STATUS_URL =
    'https://personal-d4yby5if.outsystemscloud.com/Booking_API/rest/Vouchers/v1/GetStatus';

function parseIsOn(raw) {
    if (raw === true || raw === 'true' || raw === 'True' || raw === 1) return true;
    if (raw === false || raw === 'false' || raw === 'False' || raw === 0) return false;

    if (typeof raw === 'string') {
        const trimmed = raw.trim().toLowerCase();
        if (trimmed === 'true') return true;
        if (trimmed === 'false') return false;
    }

    if (raw && typeof raw === 'object') {
        const nested = raw.IsOn ?? raw.isOn ?? raw.Result ?? raw.result;
        if (nested !== undefined) return parseIsOn(nested);
    }

    return false;
}

/** Returns whether the temporary voucher discount UI should be shown. */
export async function getVoucherDiscountStatus() {
    const response = await axios.get(GET_STATUS_URL, {
        headers: { Voucher: 30 }
    });
    return parseIsOn(response.data);
}
